// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./TextArea.CharCount.css";
import React, { createContext, useContext } from "react";
import {
  exists,
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import { RootPrimitive, TextPrimitive } from "../_internal_primitives";

const styles = [
  {
    type: "default",
    layers: {
      ATQfLQXwBH: {
        none: {
          text: "0",
        },
      },
      RE2NrZU1ea: {
        none: {
          text: "255",
        },
      },
      "7uftoTK1Bf": {
        none: {
          text: "/",
        },
      },
    },
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
];

const variantPropTypes = [];

export const CharCountContext = createContext(null);

function CharCount(_props) {
  const defaults = useContext(CharCountContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RootPrimitive
      {...props}
      key="EKKprpBtyS"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "EKKprpBtyS",
        scope: "UUdFXgTnPe",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <>
          <TextPrimitive
            id={"current_ATQfLQXwBH"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_UUdFXgTnPe_ATQfLQXwBH"
            }
            key={"ATQfLQXwBH"}
            text={
              exists(props.current)
                ? props.current
                : getStyle("ATQfLQXwBH", "text")
            }
            element={getStyle("ATQfLQXwBH", "htmlElement")}
          />
          <TextPrimitive
            id={"slash_7uftoTK1Bf"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_UUdFXgTnPe_7uftoTK1Bf"
            }
            key={"7uftoTK1Bf"}
            text={getStyle("7uftoTK1Bf", "text")}
            element={getStyle("7uftoTK1Bf", "htmlElement")}
          />
          <TextPrimitive
            id={"max_RE2NrZU1ea"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_UUdFXgTnPe_RE2NrZU1ea"
            }
            key={"RE2NrZU1ea"}
            text={
              exists(props.max) ? props.max : getStyle("RE2NrZU1ea", "text")
            }
            element={getStyle("RE2NrZU1ea", "htmlElement")}
          />
        </>
      )}
    </RootPrimitive>
  );
}

CharCount.__variants = [];

export default CharCount;
